import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class CommerceNumberServices {
  async getByAll(params: any): Promise<any[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_PAYMENT}/commerce-number/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const commerceNumberServices = new CommerceNumberServices()
